import { useRef } from 'react';

import { Flex, Icon, type ITextFieldProps, TextField } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import { ExporterColumnTextFieldStyled } from './styles/ExporterColumnTextFieldStyled'

export const ExporterColumnTextField = (props: ITextFieldProps) => {
  const intl = useIntl()
  const textInput = useRef<HTMLInputElement>(null)

  const onEditIconClick = () => {
    if (textInput?.current) {
      textInput?.current.focus()
    }
  }

  return (
    <ExporterColumnTextFieldStyled>
      <Flex.Row alignItems='center' flexWrap='nowrap' width='100%' spacing={0}>
        <Flex.Item>
          <TextField
            inputRef={textInput}
            placeholder={intl.formatMessage(messages.textfieldPlaceholder)}
            {...props}
          />
        </Flex.Item>
        <Flex.Item>
          <button className='textfield-editicon' onClick={onEditIconClick}>
            <Icon icon='edit' size={12} color='darkGrey' />
          </button>
        </Flex.Item>
      </Flex.Row>
    </ExporterColumnTextFieldStyled>
  )
}

ExporterColumnTextField.displayName = 'ExporterColumnTextField'
